import React from "react";
import "./edit-zoho.scss";
import ReactModal from "react-modal";
import Select from "react-select";
import Loader from "../../loader/loader";
import { updateZohoData } from "../../../api/index";

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid #EAEBEF",
        padding: 10,
        fontSize: 14,
        color: "#58585B",
    }),
    control: () => ({
        width: "100%",
    }),
};
class EditZoho extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            menuCLose: true,
            show_spinner: false,
            zoho_id: props.appData.zoho_id,
            zoho_submission_id: props.appData.zoho_submission_id,
            error: "",
        };
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    submitApp = () => {
        let data = {
            id: this.props.appData.id,
            zoho_id: this.state.zoho_id,
            zoho_submission_id: this.state.zoho_submission_id,
            zohoIdType: this.props.zohoIdType,
        };
        this.setState({ show_spinner: true });
        updateZohoData(data).then((res) => {
            this.setState({ show_spinner: false });
            if (res.status) {
                this.props.onClose(false);
                this.props.getAppData();
            } else {
                this.setState({
                    error: res.message,
                });
            }
        });
    };

    render() {
        const { selectedOption, show_spinner } = this.state;
        return (
            <ReactModal isOpen={this.props.isOpen} className="edit-zoho">
                <div className="modal-header">
                    <h4 className="text-left">Edit Zoho Data</h4>
                </div>
                {this.props.zohoIdType == "zoho_id" && (
                    <div className="form-group">
                        <label>Zoho ID</label>
                        <input
                            type="text"
                            className="form-control"
                            name="zoho_id"
                            value={this.state.zoho_id}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </div>
                )}
                {this.props.zohoIdType == "submission_id" && (
                    <div className="form-group">
                        <label>Zoho Submission ID</label>
                        <input
                            type="text"
                            className="form-control"
                            name="zoho_submission_id"
                            onChange={(e) => this.handleChange(e)}
                            value={this.state.zoho_submission_id}
                        />
                    </div>
                )}
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="text-danger">{this.state.error}</p>
                <div className="modal-footer">
                    <button
                        className="btn cancel-button"
                        onClick={() => this.props.onClose(false)}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn confirm-button"
                        onClick={() => this.submitApp()}
                    >
                        Assign
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default EditZoho;
